import { shrpaApi } from "@/repos/axios";
import type {
  ApplyPendingChannelsRequest,
  ApplyPendingChannelsResponse,
  ContentCalendarSystemSettingsData,
  ContentCalendarUserSettingsData,
  PendingChannelsPromptStatus,
  SocialMediaSettingsV2Response,
  UpdateSocialSettingsV2Request,
} from "@/contracts/socialMediaSettings";
import { getCalendarId } from "@logic/calendarManager";

const basePath = "/social-media-settings";

export default class SocialMediaSettingsRepo {
  static async getSettings(customerId: string): Promise<SocialMediaSettingsV2Response> {
    const calendarId = await getCalendarId(customerId);
    const response = await shrpaApi.get(`${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/v2`);
    return response.data as SocialMediaSettingsV2Response;
  }

  static async updateSettings(userSettings: ContentCalendarUserSettingsData, timeZone: string | null): Promise<SocialMediaSettingsV2Response> {
    if (!userSettings?.id || !userSettings?.customerId) throw new Error("userSettings.id and userSettings.customerId are required");
    const calendarId = await getCalendarId(userSettings.customerId);
    const url = `${basePath}/${encodeURIComponent(userSettings.customerId)}/${encodeURIComponent(calendarId)}/${encodeURIComponent(userSettings.id)}/v2`;
    const payload: UpdateSocialSettingsV2Request = { userSettings, timeZone };
    const response = await shrpaApi.put(url, payload);
    return response.data as SocialMediaSettingsV2Response;
  }

  static async checkForLinkedAccount(customerId: string): Promise<ContentCalendarSystemSettingsData> {
    const calendarId = await getCalendarId(customerId);
    const url = `${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/check-for-linked-account`;
    const response = await shrpaApi.put(url);
    return response.data as ContentCalendarSystemSettingsData;
  }

  static async getPendingChannelsStatus(customerId: string): Promise<PendingChannelsPromptStatus> {
    const calendarId = await getCalendarId(customerId);
    const url = `${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/pending-channels-status`;
    const response = await shrpaApi.get(url);
    return response.data as PendingChannelsPromptStatus;
  }

  static async applyPendingChannels(customerId: string, addToApprovedPosts: boolean): Promise<ApplyPendingChannelsResponse> {
    const calendarId = await getCalendarId(customerId);
    const url = `${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/apply-pending-channels`;
    const payload: ApplyPendingChannelsRequest = { addToApprovedPosts };
    const response = await shrpaApi.put(url, payload);
    return response.data as ApplyPendingChannelsResponse;
  }
}
